import type { ReasonCodes } from "../../types/operations/osad.type";

export const mockReasonCodes = {
  default: [
    {
      id: 79,
      name: "All Short",
      description:
        "Marks as all short and places the shipment in OSAD for visibility",
    },
    {
      id: 80,
      name: "Other",
      description: "Moves shipments to the OSAD section",
    },
  ],
} as const satisfies Record<string, ReasonCodes[]>;
